import { faMoon } from '@fortawesome/free-solid-svg-icons/faMoon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TableHeader } from 'components/UI/V3/Table/Header/TableHeader';
import { TableHeaderCell } from 'components/UI/V3/Table/HeaderCell/TableHeaderCell';
import Checkbox from 'components/UI/V3/Forms/Checkbox';
import { Sort } from '@spike/model';
import { FunctionComponent } from 'react';
import styles from './BoardingHeaderTable.module.scss';
import HeaderTableColumn from './HeaderTableColumn';
import { appointmentSortColumns } from './groomingSort';

interface BoardingHeaderTableProps {
    sort: Sort | null;
    onSort?: (sort: Sort) => void;
    allSelected?: boolean;
    onToggleSelectAll?: (checked: boolean) => void;
}

export const BoardingHeaderTable: FunctionComponent<BoardingHeaderTableProps> = props => {
    return (
        <TableHeader>
            {props.onToggleSelectAll && (
                <TableHeaderCell className={styles.checkboxCell}>
                    <Checkbox
                        checked={props.allSelected}
                        onChange={props.onToggleSelectAll}
                    />
                </TableHeaderCell>
            )}
            <HeaderTableColumn
                sortColumn={appointmentSortColumns.client}
                selectedSort={props.sort}
                onServerSort={props.onSort}
            >
                Client Name
            </HeaderTableColumn>
            <HeaderTableColumn
                sortColumn={appointmentSortColumns.pet}
                selectedSort={props.sort}
                onServerSort={props.onSort}
            >
                Pet Name
            </HeaderTableColumn>
            <HeaderTableColumn
                sortColumn={appointmentSortColumns.service}
                selectedSort={props.sort}
                onServerSort={props.onSort}
            >
                Service
            </HeaderTableColumn>
            <HeaderTableColumn
                sortColumn={appointmentSortColumns.room}
                selectedSort={props.sort}
                onServerSort={props.onSort}
            >
                Room
            </HeaderTableColumn>
            <HeaderTableColumn
                sortColumn={appointmentSortColumns.checkIn}
                selectedSort={props.sort}
                onServerSort={props.onSort}
            >
                Check In
            </HeaderTableColumn>
            <HeaderTableColumn
                sortColumn={appointmentSortColumns.checkOut}
                selectedSort={props.sort}
                onServerSort={props.onSort}
            >
                Check Out
            </HeaderTableColumn>
            <HeaderTableColumn
                sortColumn={appointmentSortColumns.nights}
                selectedSort={props.sort}
                onServerSort={props.onSort}
                className={styles.nights}
            >
                <FontAwesomeIcon icon={faMoon} />
            </HeaderTableColumn>
            <HeaderTableColumn
                sortColumn={appointmentSortColumns.total}
                selectedSort={props.sort}
                onServerSort={props.onSort}
            >
                Total
            </HeaderTableColumn>
            <HeaderTableColumn
                sortColumn={appointmentSortColumns.status}
                selectedSort={props.sort}
                onServerSort={props.onSort}
            >
                Status
            </HeaderTableColumn>
        </TableHeader>
    );
};

export default BoardingHeaderTable;
